<template>
  <div v-if="extraFields" class="overflow-x-auto">
    <table class="min-w-full divide-y divide-gray-300">
      <!-- Cabeçalho -->
      <thead>
        <tr>
          <th v-for="(key, index) in tableHeaders" :key="index" scope="col" class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900">
            {{ key }}
          </th>
          <th scope="col" class="relative whitespace-nowrap py-3.5 pl-3 pr-4 sm:pr-0">
            <span class="sr-only">Deletar</span>
          </th>
        </tr>
      </thead>

      <!-- Corpo da tabela -->
      <tbody class="divide-y divide-gray-200 bg-white">
        <tr v-for="(row, rowIndex) in extraFields" :key="rowIndex" class="hover:bg-gray-100">
          <td v-for="(value, key) in row" :key="key" class="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
            {{ value }}
          </td>
          <td class="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
            <a @click.prevent="emitRemove(rowIndex)" href="#" class="text-indigo-600 hover:text-indigo-900">Deletar<span class="sr-only">, {{ rowIndex }}</span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
  
  <script>
  export default {
    name: 'DynamicTable',
    props: {
      extraFields: {
        type: Array,
        required: true
      }
    },
    computed: {
      // Pega as chaves do primeiro objeto em extraFields para gerar o cabeçalho
      tableHeaders() {
        if (this.extraFields.length > 0) {
          return Object.keys(this.extraFields[0]);
        } else {
          return [];
        }
      },
    },
    methods:{
      
      emitRemove(index) {
        this.$emit('remove-item', index);
      }
    }
  }
  </script>
  
  <style scoped>
  /* Adicione estilos personalizados aqui, se necessário */
  </style>
  